module.exports = __webpack_public_path__ + "static/img/03.28c8161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/03.png
// module id = ocIF
// module chunks = 1